import loadable from '@loadable/component';

import publicListQuery from './query.graphql';

import { LIMIT } from './constants';

const PublicList = loadable(() =>
  import(/* webpackChunkName: "lists" */ './public-list')
);

PublicList.graphQL = publicListQuery;

PublicList.variables = ({ id, offset }) => {
  return {
    id: Number(id),
    limit: LIMIT,
    offset: offset !== undefined ? Number(offset) : 0,
  };
};

PublicList.loadOrder = [{}];

export default PublicList;
